<template>
  <div class="container">
    <!--Section: Content-->
    <section class="formation">
      <!-- Section heading -->
      <h2 class="text-center font-weight-bold">Formations Mobilité</h2>
      <!-- Section description -->
      <div class="mx-auto w-responsive">
        <div class="container">
          <!--Section: Content-->
          <section class="text-center">
            <!-- Section heading -->
            <p
              class="text-center argument font-weight-bold dark-grey-text pb-2 my-4"
            >
              les meilleurs offres
            </p>
            <!-- Section description -->
            <p class="text-center w-responsive mx-auto mb-5">
              Les
              <strong>formations en mobilité et passerelle</strong>, conçues
              pour vous permettre d'élargir vos compétences dans le
              <strong>secteur des transports et de la mobilité</strong>.
            </p>

            <ServicePricingCarousel
              eyebrow="Formation mobilité"
              :offers="carouselOffers"
            />
          </section>
          <!--Section: Content-->
        </div>
      </div>
      <div class="hr-d"></div>
      <CallToContact
        title="Contactez nous"
        subTitle="L'equipe pédagogique de l'institut taxi s'occupe de vos démarches administratives."
      />
    </section>
    <!--Section: Content-->
  </div>
  <section class="container-fluid double-block">
    <div class="double-block__title">
      <h2>
        Votre centre de formation agréé pour<br />
        les taxi et vtc.
      </h2>
    </div>
    <div class="dark-grey-text double-block__articles">
      <ServiceFeatureBlock
        title="Étendez votre zone d'activité"
        tone="secondary"
        :copy-html="featureCopy.intro"
      >
        <template #media>
          <img
            src="@/assets/pictures/passerelle.webp"
            alt="uber-order-phone"
            class="img-fluid"
            loading="lazy"
          />
        </template>
      </ServiceFeatureBlock>
      <div class="hr-d"></div>
      <ServiceFeatureBlock
        title="Changez de statut sans repartir de zéro"
        tone="primary"
        reverse
        :copy-html="featureCopy.bridge"
      >
        <template #media>
          <img
            src="@/assets/pictures/man-vtc.webp"
            alt="man-drive-car"
            class="img-fluid"
            loading="lazy"
          />
        </template>
      </ServiceFeatureBlock>
    </div>
  </section>
</template>

<script>
import CallToContact from "@/components/plugins/CallToContact.vue";
import ServiceFeatureBlock from "./ServiceFeatureBlock.vue";
import ServicePricingCarousel from "./ServicePricingCarousel.vue";

const featureCopy = {
  intro:
    "Les <strong>formations mobilité</strong> permettent aux <strong>chauffeurs de taxi</strong> d'étendre leur activité vers <strong>Paris (75)</strong> et les <strong>Hauts-de-Seine (92)</strong>. Vous y travaillez les zones clés, les itinéraires utiles, les habitudes locales et les règles propres à ces secteurs. C'est un module ciblé pour répondre à davantage de demandes et couvrir de nouveaux territoires avec plus d'assurance. Vous élargissez ainsi votre zone d'intervention avec un cadre plus clair et plus sûr. Cette préparation vous aide aussi à mieux lire le terrain, à gagner en repères locaux et à intervenir avec plus de fluidité dans des secteurs à forte demande.",
  bridge:
    "La passerelle <strong>taxi vers VTC</strong>, ou <strong>VTC vers taxi</strong>, permet de changer de statut sans repartir de zéro. La formation cible les différences de réglementation, de pratique et d'examen afin de sécuriser la transition. Vous gagnez du temps, conservez un cadre pédagogique clair et avancez vers le nouveau métier avec un parcours direct et opérationnel. C'est la solution pour évoluer sans repartir sur un cursus complet. Le format met l'accent sur les écarts réellement utiles entre les deux activités, pour rendre la conversion plus rapide, plus lisible et plus cohérente avec votre expérience déjà acquise.",
};

const carouselOffers = [
  {
    id: "mobilite-92-75",
    eyebrow: "Mobilité taxi",
    title: "Mobilité",
    badge: "92 / 75",
    price: "449",
    route: "/formation-mobilite-taxi-92",
    meta: [
      { label: "Volume", value: "14h" },
      { label: "Planning", value: "Horaires à convenir" },
    ],
    note: {
      title: "Zone étendue",
      text: "Cette formation permet d'ajouter Paris (75) et les Hauts-de-Seine (92) à votre carte professionnelle taxi pour élargir votre zone d'activité avec un cadre réglementaire clair.",
    },
    highlights: [],
    variant: "primary",
  },
  {
    id: "passerelle-taxi-vtc",
    eyebrow: "Passerelle professionnelle",
    title: "Passerelle",
    badge: "Taxi > VTC",
    price: "600",
    fee: "+162€ frais examen CMA",
    route: "/formation-mobilite-passerelle-taxi-vers-vtc",
    meta: [
      { label: "Volume", value: "5 jours" },
      { label: "Planning", value: "Disponibilités à convenir" },
    ],
    note: {
      title: "Transition",
      text: "Cette passerelle permet de basculer vers l'activité VTC sans repartir sur une formation complète. Vous travaillez les règles, la relation client et les spécificités du métier.",
    },
    highlights: ["Véhicule mis à disposition le jour de l'examen"],
    variant: "light",
  },
  {
    id: "passerelle-vtc-taxi",
    eyebrow: "Passerelle professionnelle",
    title: "Passerelle",
    badge: "VTC > Taxi",
    price: "600",
    fee: "+162€ frais examen CMA",
    route: "/formation-mobilite-passerelle-vtc-vers-taxi",
    meta: [
      { label: "Volume", value: "5 jours" },
      { label: "Planning", value: "Disponibilités à convenir" },
    ],
    note: {
      title: "Transition",
      text: "Cette formule prépare la conversion vers l'activité taxi avec un focus sur la réglementation, la gestion de l'activité et les spécificités du terrain.",
    },
    highlights: ["Véhicule mis à disposition le jour de l'examen"],
    variant: "light",
  },
  {
    id: "taxi-elearning",
    eyebrow: "Formation taxi",
    title: "E-learning",
    badge: "Taxi en ligne",
    price: "549",
    fee: "Frais d'examen inclus",
    route: "/formation-taxi-en-ligne",
    meta: [
      { label: "Durée", value: "1 mois" },
      { label: "Support", value: "Application ludo-pédagogique" },
      { label: "Questions", value: "Entre 1 000 et 1 500" },
    ],
    highlights: [
      "4 fois 137,25€ sans frais",
      "QCM, jeux, duels, etc.",
      "Théorie et pratique avec véhicule",
      "Examen blanc inclus",
    ],
    variant: "primary",
  },
  {
    id: "vtc-elearning",
    eyebrow: "Formation VTC",
    title: "E-learning",
    badge: "VTC en ligne",
    price: "549",
    fee: "Frais d'examen inclus",
    route: "/formation-vtc-en-ligne",
    meta: [
      { label: "Durée", value: "1 mois" },
      { label: "Support", value: "Application ludo-pédagogique" },
      { label: "Questions", value: "Entre 1 000 et 1 500" },
    ],
    highlights: [
      "4 fois 137,25€ sans frais",
      "QCM, jeux, duels, etc.",
      "Théorie et pratique avec véhicule",
      "Examen blanc inclus",
    ],
    variant: "primary",
  },
];
export default {
  name: "ServicesMobilite",
  components: { CallToContact, ServiceFeatureBlock, ServicePricingCarousel },
  data() {
    return {
      carouselOffers,
      featureCopy,
    };
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
};
</script>

<style lang="scss" scoped>
.formation {
  & h2 {
    text-align: center;
    background-color: $color-primary;
    color: $color-secondary;
    padding: 10px;
  }
  & .argument {
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 1.3em;
  }
  .price-card {
    & .card {
      color: $color-text-light;
      background: #000000; /* fallback for old browsers */
      background: -webkit-linear-gradient(
        to bottom,
        #434343,
        #000000
      ); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(
        to bottom,
        #434343,
        #000000
      ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

      & h3 {
        background-color: $color-primary;
        font-family: "quantum";
        color: $color-text-light;
        padding: 10px;
      }
      & .price {
        text-align: center;
        font-size: 2em;
        margin-bottom: 0px;
        & span {
          color: $color-secondary;
        }
      }
      & .priceBis {
        text-align: center;
        font-size: small;
        margin-bottom: 20px;
      }
      & .card-body {
        padding: 0px;
        & ul {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          list-style-type: none;
          padding: 0px;
          & li,
          p {
            text-align: center;
          }
        }
      }
      & .card-footer {
        background-color: $color-secondary;
        padding: 0px;
      }
    }
  }
}
.double-block {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(110px, 10vw, 138px);
  }

  &__title {
    width: min(100%, 1040px);
    padding: 0;
    text-align: center;
    margin: 0 auto 44px;

    & h2 {
      margin: 0;
      font-family: "Spartan", "Arial Black", Arial, sans-serif;
      font-weight: 700;
      color: $color-primary;
      font-size: clamp(1.56rem, 1.18rem + 0.98vw, 2.3rem);
      line-height: 1.02;
      letter-spacing: 0.03em;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
        0 14px 28px rgba(0, 42, 84, 0.08);
    }

    @media screen and (min-width: 992px) {
      margin-bottom: 56px;
    }
  }

  &__articles {
    width: min(100%, 1180px);
    margin: 0 auto;

    > .hr-d {
      width: 94px;
      height: 4px;
      margin: 34px auto 38px;
      border-radius: 999px;
      background: $color-secondary;
      opacity: 1;
      box-shadow: 0 10px 22px rgba(254, 185, 20, 0.18);

      @media screen and (min-width: 992px) {
        margin: 40px auto 44px;
      }
    }
  }
}
.slide-right.active {
  @include slide-right(1.2s);
}
.slide-left.active {
  @include slide-left(1.2s);
}
.fall.active {
  @include fall-down(1s);
}
</style>
